import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { ROUTES } from 'config/routes';
import LoadingSkeleton from 'components/feedback/LoadingSkeleton';
import {
  HomePage,
  CatalogPage,
  CategoryPage,
  SubcategoryPage,
  BrandPage,
  BrandsPage,
  PromotionsPage,
  NewsPage,
  ContentPage,
  ContactPage,
  ProductDetailPage,
  SearchResultsPage,
  CartPage,
  OrderTrackingPage,
} from 'pages';

const Lazy = ({
  children,
  fallback = <LoadingSkeleton rows={4} height={18} />,
}: {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) => <Suspense fallback={fallback}>{children}</Suspense>;

const catalogFallback = <LoadingSkeleton variant="cards" heading count={8} />;

export const publicRoutes = (
  <>
    <Route index element={<Lazy fallback={<LoadingSkeleton variant="page" />}><HomePage /></Lazy>} />
    <Route path={ROUTES.CATALOG} element={<Lazy fallback={catalogFallback}><CatalogPage /></Lazy>} />
    <Route path={ROUTES.CATEGORY} element={<Lazy fallback={catalogFallback}><CategoryPage /></Lazy>} />
    <Route path={ROUTES.SUBCATEGORY} element={<Lazy fallback={catalogFallback}><SubcategoryPage /></Lazy>} />
    <Route path={ROUTES.PRODUCT} element={<Lazy fallback={<LoadingSkeleton variant="detail" />}><ProductDetailPage /></Lazy>} />
    <Route path={ROUTES.SEARCH} element={<Lazy fallback={catalogFallback}><SearchResultsPage /></Lazy>} />
    <Route path={ROUTES.BRANDS} element={<Lazy fallback={<LoadingSkeleton variant="tiles" count={8} />}><BrandsPage /></Lazy>} />
    <Route path={ROUTES.BRAND} element={<Lazy fallback={catalogFallback}><BrandPage /></Lazy>} />
    <Route path={ROUTES.PROMOTIONS} element={<Lazy fallback={catalogFallback}><PromotionsPage /></Lazy>} />
    <Route path={ROUTES.NEWS} element={<Lazy fallback={catalogFallback}><NewsPage /></Lazy>} />
    <Route path={ROUTES.CONTENT_PAGE} element={<Lazy><ContentPage /></Lazy>} />
    <Route path={ROUTES.CONTACT} element={<Lazy><ContactPage /></Lazy>} />
    <Route path={ROUTES.CART} element={<Lazy><CartPage /></Lazy>} />
    <Route path={ROUTES.ORDER_TRACKING} element={<Lazy><OrderTrackingPage /></Lazy>} />
  </>
);
